<template>
  <div>
    <van-form>
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="购物开始时间"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="购物结束时间"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="状态"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="资产类别"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="供应商"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="详细类别"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="资产名称"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="业务单元"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="业务子单元"
        placeholder="请选择"
      />
    </van-form>
    <div class="mt10">
      <van-button round block type="primary">查询</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        formData:{},
        enddate: '',
        isshow3: false,
        isshow: false,
        columns: 1,
        statecon: {
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '库存',
              value: '库存'
            },
            {
              text: '已转售',
              value: '已转售'
            }
          ]
        },
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
      }
    },
    mounted() {
      this.GetCustomer()
    },
    methods: {
      concus(val) {
        var btn2 = document.getElementById('btncon1')
        console.log(val.select1.value)
        this.isshow = false
        btn2.value = val.select1.value
        this.res = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      stateCon(val) {
        var btn4 = document.getElementById('btncon3')
        this.isshow3 = false
        btn4.value = val.select1.value
        this.res = btn4.value
        // console.log(JSON.parse(this.defaultData))
      },
      GetCustomer() {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayeeJson',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList = res.data.result
          // custormlog.style.display="block"
          this.customercon.data1 = new Array();
          for (var i = 0; i < this.customerList.length; i++) {
            this.customercon.data1.push({"text": this.customerList[i].Name, "value": this.customerList[i].Name})
          }
        })
      },
    }
  }
</script>

